<template>
  <v-layout row justify-center>
    <v-dialog v-model="showFaviconForm" max-width="600px">
      <v-form>
        <v-card class="modern-modal">
          <div class="modal-head">
            <div class="modal-head-icon"><v-icon color="white">image</v-icon></div>
            <span class="modal-head-title">Alterar Favicon</span>
          </div>
          <v-card-text>
            <div v-show="loading" class="text-xs-center">
              <v-progress-circular
                indeterminate
                v-bind:color="color"
              ></v-progress-circular>
            </div>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <label for="avatar">Escolha a imagem para o favicon:</label>
                  <input type="file" id="partner_favicon" ref="partner_favicon" v-on:change="handleFileUpload()"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showChangeFaviconForm">Fechar</v-btn>
            <v-btn color="primary" @click="sendFavicon">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'faviconForm',
  data: () => ({
    newFavicon: null,
    partner_favicon: ''
  }),
  created() {
    
  },
  computed: {
    ...mapGetters({
      showFaviconForm: "account/showFaviconForm",
      loading: "account/loading",
      color: "account/color",
    }),
  },
  watch: {
    // Watcher removido para evitar conflitos com computed properties
  },
  methods: {
    showChangeFaviconForm() {
      this.$store.dispatch('account/showFaviconForm', false);
    },
    handleFileUpload(){
      this.partner_favicon = this.$refs.partner_favicon.files[0];
    },
    sendFavicon() {
      this.formData = new FormData();
      this.formData.append('partner_favicon', this.partner_favicon);
      this.$store.dispatch('account/sendFavicon', this.formData);
    }
  },
};
</script>
